import PropTypes from 'prop-types';
import { forwardRef } from 'react';

import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { useTheme } from '@mui/material/styles';

import { RouterLink } from '@/routes/components';

// ----------------------------------------------------------------------

const Logo = forwardRef(({ disabledLink = false, sx, ...other }, ref) => {
  const theme = useTheme();

  const PRIMARY_LIGHT = theme.palette.primary.light;

  const PRIMARY_MAIN = theme.palette.primary.main;

  const PRIMARY_DARK = theme.palette.primary.dark;

  // OR using local (public folder)
  // -------------------------------------------------------
  // const logo = (
  //   <Box
  //     component="img"
  //     src="/logo/logo_single.svg" => your path
  //     sx={{ width: 40, height: 40, cursor: 'pointer', ...sx }}
  //   />
  // );

  const logo = (
    <Box
      ref={ref}
      component="div"
      sx={{
        width: 40,
        height: 40,
        display: 'inline-flex',
        ...sx,
      }}
      {...other}
    >
        <svg width="100%" height="100%" viewBox="0 0 1024 1024" className="icon" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M836.136692 0h-127.975005l-191.962507 143.97188 60.588166 45.391135c7.298574-2.09959 14.297208-5.598906 20.495997-10.198008L836.136692 0z"
                fill="#8C9EFF"/>
            <path
                d="M192.062488 160.168717v703.862527c0 35.293107 28.694396 63.987502 63.987502 63.987502h511.90002c35.293107 0 63.987502-28.694396 63.987502-63.987502V160.168717c0-35.293107-28.694396-63.987502-63.987502-63.987502H256.04999c-35.293107 0-63.987502 28.694396-63.987502 63.987502z m479.906268 63.987502H352.031244c-17.696544 0-31.993751-14.297208-31.993751-31.993751s14.297208-31.993751 31.993751-31.993751h319.937512c17.696544 0 31.993751 14.297208 31.993751 31.993751s-14.297208 31.993751-31.993751 31.993751z"
                fill="#3D5AFE"/>
            <path
                d="M703.962507 512.09998c0-109.678578-39.392306-210.058973-104.779535-287.943761H352.031244c-17.696544 0-31.993751-14.297208-31.993751-31.993751s14.297208-31.993751 31.993751-31.993751h181.164616c-33.393478-26.294864-70.486233-47.990627-110.578402-63.987502H256.04999c-35.293107 0-63.987502 28.694396-63.987502 63.987502v703.862527c0 35.293107 28.694396 63.987502 63.987502 63.987502h166.567468C587.485257 861.931654 703.962507 700.663152 703.962507 512.09998z"
                fill="#536DFE"/>
            <path
                d="M324.136692 0h-127.975005l238.95333 179.165007c6.198789 4.599102 13.097442 8.098418 20.495996 10.198008 5.698887 1.699668 11.597735 2.499512 17.596564 2.599492h85.583284c6.098809 0 12.097637-0.899824 17.896505-2.599492L324.136692 0z"
                fill="#FFEA00"/>
            <path
                d="M416.018746 448.312439a119.976567 95.981254 90 1 0 191.962508 0 119.976567 95.981254 90 1 0-191.962508 0Z"
                fill="#FFEA00"/>
            <path
                d="M617.67936 799.843781c115.177504 0 131.674282-53.289592 35.793009-117.077134-40.492091-26.894747-89.182582-42.591681-141.472369-42.591681s-100.880297 15.696934-141.472369 42.591681c-95.981254 63.787541-79.384495 117.077133 35.793009 117.077134h211.35872z"
                fill="#FFEA00"/>
        </svg>
    </Box>
  );

  if (disabledLink) {
    return logo;
  }

  return (
    <Link component={RouterLink} href="/" sx={{ display: 'contents' }}>
      {logo}
    </Link>
  );
});

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default Logo;
